define.alias("shared/components/shared/pre-boarding/auto-trial-end/index", "calendar/components/shared/pre-boarding/auto-trial-end");